import { CopilotRoleEnum } from "~/utils/enums/copilot/chat.enums";

/**
 * Who is speaking, for assistive tech only. The design paints no author name, so side and colour are
 * the whole cue on screen — and neither reaches a screen reader.
 */
export function messageSpeakerLabelOf(role: CopilotRoleEnum): string {
  return role === CopilotRoleEnum.USER ? "Vous :" : "Simbel AI :";
}

/** Both speakers get a bubble: the user's hugs its text up to 85% of the panel, the assistant's fills it. */
export function messageBubbleClassOf(role: CopilotRoleEnum, bare: boolean, compact: boolean): string {
  const isUser = role === CopilotRoleEnum.USER;

  if (bare) return isUser ? "max-w-full rounded-tr-none" : "w-full rounded-tl-none";
  if (compact && !isUser) return "w-fit rounded-tl-none";

  // Light blue for the human, lightest blue for the assistant: the speakers are told apart by colour.
  return isUser
    ? "max-w-[85%] rounded-tr-none bg-light-blue-color px-4 py-2"
    : "w-full rounded-tl-none bg-lightest-blue-color px-4 py-2.5";
}
